'use client'
import { Player } from "@lottiefiles/react-lottie-player";
import { PrismicLink, PrismicRichText } from "@prismicio/react";
import { useState } from "react";


/**
 * @typedef {import("@prismicio/client").Content.AssetsSlice} AssetsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<AssetsSlice>} AssetsProps
 * @param {AssetsProps}
 */

const AssetsCard = ({ card, index }) => {
  const [isOpen, setIsOpen] = useState(false);
  function toggle() {
    setIsOpen(!isOpen);
  }

  return <div className="card-h bg-white border-2 border-dark-grey rounded-30px px-30px py-4 mb-5 md:p-10 lg:w-1/3 overflow-hidden faq-wrapper-parent">
    <div className="flex items-center justify-between h3-like lg:mb-2 toggle-btn faq-wrapper" onClick={toggle}>
      <PrismicRichText field={card.title} />
      <div className="w-fit  ml-2.5 md:hidden ">
        <div className={`spin_arrow h-2 w-4 ${isOpen ? 'toggle-active' : ''}`}>
          <img width={16} height={8} src='/svg/arrow-faq.svg' className="w-full h-auto"  loading={index === 0 ? '' : 'lazy'} alt="flèche"/>
        </div>
      </div>
    </div>
    <div className={`mt-2.5 ${isOpen ? '' : 'hidden'} md:block`}>
      <PrismicRichText field={card.text} />
    </div>
  </div>
}
const Assets = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-light-pink bg-coulure-asset overflow-x-hidden pb-[40px] md:pb-20 relative">
      <div className="h-auto w-screen mb-14 z-[10] hidden md:block">
        <Player
          id="home-asset"
          autoplay={true}
          loop={true}
          mode="normal"
          src="/anim/animation-defilement.json">
        </Player>
      </div>

      <div className="md:hidden md:w-screen md:h-auto mb-11 relative z-[10]">
        <Player
          id="home-asset-mobile"
          autoplay={true}
          loop={true}
          mode="normal"
          src="/anim/animation-defilement mobile.json">
        </Player>
      </div>


      <div className="px-4 md:px-7 lg:px-10 max-w-[1400px] m-auto text-dark-grey relative z-[10]">
        <div className="md:text-center mb-30px md:mb-[50px] h2-like max-w-[1000px] m-auto">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div className="lg:flex lg:justify-between mb-10 gap-x-10">
          {
            slice.primary.cards.map((card, i) => <AssetsCard index={index} card={card} key={i} />)
          }
        </div>
        <div className="text-center">
          <div className="button button-rounded button-text overflow-hidden background-slide-white">
            <PrismicLink field={slice.primary.cta_page}
              className="cta_form">
              {slice.primary.cta_label}
            </PrismicLink>
          </div>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>
    </section >
  );
};

export default Assets;
